import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { openModal } from 'common/src/app/actions/components/modalActions';
import ModalNames from 'common/src/app/data/enum/ModalNames';
import Colors from 'common/src/app/data/enum/Colors';
import Wrapper from '../../atoms/Wrapper';
import * as ContactUsForm from '../../organisms/ContactUsForm';
import accountStateProvider from '../../hoc/AccountStateProvider';
import HandleErrorComponent from './HandleErrorComponent';

const mapDispatchToProps = (dispatch, { componentName, accountType }) => ({
  openContactFormModal: () =>
    dispatch(
      openModal(
        ModalNames.CONTENT,
        {
          showWrapperCloseButton: false,
          children: (
            <Wrapper width="ls" background={Colors.PRIMARY_LIGHT} padding="lg" paddingBottom="lg">
              <ContactUsForm.Member
                userType={accountType}
                errorBoundaryData={{ location: window.location.href, componentName }}
              />
            </Wrapper>
          ),
        },
        false,
        false,
        true,
      ),
    ),
});

const connected = connect(null, mapDispatchToProps);

export default compose(accountStateProvider(), connected)(HandleErrorComponent);
